import React from 'react';
import { ThumbsUpIcon, ThumbsUpFillIcon } from '../LegacyIcons';
import classnames from 'classnames';

const UpvoteButton = ({
  onClick,
  disabled,
  count,
  children,
  highlightVotes,
  hasVoted,
}) => {
  const classes = classnames('c-upvote-button', {
    'c-upvote-button--has-votes': !!count,
    'c-upvote-button--no-votes': !count,
    'c-upvote-button--highlight-votes': highlightVotes,
    'has-voted': hasVoted,
  });

  return (
    <button className={classes} onClick={onClick} disabled={disabled}>
      <span className="c-upvote-button__icon">
        {hasVoted ? (
          <ThumbsUpFillIcon size="xx-small" />
        ) : (
          <ThumbsUpIcon size="xx-small" />
        )}
      </span>
      <span className="c-upvote-button__label">
        {count > 0 && <span className="c-upvote-button__count">{count}</span>}
        {children && <span className="c-upvote-button__text">{children}</span>}
      </span>
    </button>
  );
};

export default UpvoteButton;
